import React from 'react';
import PropTypes from 'prop-types';
import naturalCompare from 'natural-compare-lite';
import { styled, Box } from '@material-ui/core';
import Chip from 'material-ui/Chip';
import { chipsStyle } from '../../../theme/AllocateBaseTheme';
import globals from '../../../globals/communityGlobals';
import { lowerFirstLetter } from '../../../utils/helpers';

const styles = {
  selector: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
};

const StyledChipsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  '& > .selectorChip': {
    overflow: 'hidden',
    '& > span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& > svg': {
      height: '24px',
      width: '24px',
      overflow: 'visible',
    },
  },
}));

class SelectorChips extends React.Component {
  generateSortedSingleChipMap = () => {
    const { value, options } = this.props;
    return {
      id: value,
      name: options.find(o => o.id === value) !== undefined ? options.find(o => o.id === value).name : null,
    };
  };

  generateSortedMultipleChipsMap = () => {
    const { value, options } = this.props;
    const chipsMapMultiple = value
      .filter(v => options.find(o => o.id === v) !== undefined)
      .map(v => ({
        id: v,
        name: options.find(o => o.id === v).name,
      }));

    return chipsMapMultiple.sort((a, b) => naturalCompare(a.name, b.name));
  };

  render() {
    const { disabled, handleRequestDelete, localeArea, showSelectorChip } = this.props;
    const locale = localeArea ? globals.getArea(localeArea) : {};

    const sortedChipsMap = showSelectorChip
      ? this.generateSortedSingleChipMap()
      : this.generateSortedMultipleChipsMap();

    return (
      <StyledChipsContainer style={styles.selector}>
        {!showSelectorChip &&
          sortedChipsMap.map(({ id, name }) => (
            <Chip
              style={chipsStyle.style}
              className="selectorChip"
              onRequestDelete={!disabled ? handleRequestDelete(id) : null}
              key={`selectorChip${name + id}`}
            >
              {localeArea ? locale.getMsg(lowerFirstLetter(name)) : name}
            </Chip>
          ))}
        {showSelectorChip && sortedChipsMap.name !== null && (
          <Chip
            style={chipsStyle.style}
            onRequestDelete={!disabled ? handleRequestDelete(sortedChipsMap.id) : null}
            key={`selectorChip${sortedChipsMap.name + sortedChipsMap.id}`}
          >
            {localeArea ? locale.getMsg(lowerFirstLetter(sortedChipsMap.name)) : sortedChipsMap.name}
          </Chip>
        )}
      </StyledChipsContainer>
    );
  }
}

SelectorChips.defaultProps = {
  value: null,
  options: null,
  disabled: false,
  localeArea: '',
  showSelectorChip: false,
};

const optionPropType = PropTypes.shape({
  id: PropTypes.number,
  value: PropTypes.number,
  name: PropTypes.string,
});

SelectorChips.propTypes = {
  options: PropTypes.arrayOf(optionPropType),
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
  handleRequestDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  localeArea: PropTypes.string,
  showSelectorChip: PropTypes.bool,
};

export default SelectorChips;
